import { type FC } from 'react';
import styled from 'styled-components';

import { EsgCategory } from '@/api/esg/models/EsgCategory';
import { Grid } from '@/components/Grid';
import { useTexts } from '@/hooks/useTexts';

import { EsgCoverageText } from '../../components/EsgCoverageText';
import { EsgInsufficientDataAlert } from '../../components/EsgInsufficientDataAlert';
import { EsgValueText } from '../../components/EsgValueText';

interface Props {
  data: EsgCategory | undefined;
}

export const EsgCarbonFootprintTonnage: FC<Props> = ({ data }) => {
  const texts = useTexts();
  const { emissions, tonnage } = texts.pages.esg.carbonFootprint;

  if (!data) {
    return <EsgInsufficientDataAlert />;
  }

  return (
    <GridStyled>
      <OverviewContainer>
        <p className="font-body">{emissions}</p>
        <EsgValueText value={data.kpi.value} unit={tonnage} />
        <EsgCoverageText percentage={data.kpi.coverageInPercent} />
      </OverviewContainer>
    </GridStyled>
  );
};

const GridStyled = styled(Grid)`
  flex: 1;
`;

const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
